/**
 *
 * @param template translation string
 * @param placeholders value to replace
 * @returns
 */
// Example usage:
// const message = replacePlaceholders(
//     resources.createOrderProductsOrderLevelQuantityUpdateToastMessage,
//     {
//         productNumber: productNumber!,
//         minimumQty: highestMinimumQty.toString(),
//         unit: productUnit!
//     }
// );
export const replacePlaceholders = (template: string, placeholders: { [key: string]: string }): string => {
    // eslint-disable-next-line security/detect-object-injection
    return template?.replace(/{(.*?)}/g, (_, key) => placeholders[key] || '');
};
